import { useEffect, useRef } from "react";

// Lightweight custom cursor: a solid dot that snaps, and a ring that trails.
export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const pos = useRef({ x: -100, y: -100 });
  const ring = useRef({ x: -100, y: -100 });
  const raf = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;

    const onMove = (e) => {
      pos.current = { x: e.clientX, y: e.clientY };
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
      }
      const root = document.documentElement;
      root.style.setProperty("--mx", `${e.clientX}px`);
      root.style.setProperty("--my", `${e.clientY}px`);
    };

    const onOver = (e) => {
      const interactive = e.target.closest(
        "a, button, input, textarea, select, [data-cursor='hover'], [role='button']"
      );
      if (ringRef.current) {
        ringRef.current.style.width = interactive ? "64px" : "40px";
        ringRef.current.style.height = interactive ? "64px" : "40px";
        ringRef.current.style.borderColor = interactive
          ? "rgba(255,255,255,0.9)"
          : "rgba(255,255,255,0.5)";
      }
    };

    const loop = () => {
      ring.current.x += (pos.current.x - ring.current.x) * 0.18;
      ring.current.y += (pos.current.y - ring.current.y) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ring.current.x}px, ${ring.current.y}px) translate(-50%, -50%)`;
      }
      raf.current = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    raf.current = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(raf.current);
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="vs-cursor" aria-hidden />
      <div
        ref={ringRef}
        className="vs-cursor-ring"
        style={{ transition: "width .25s ease, height .25s ease, border-color .25s ease" }}
        aria-hidden
      />
    </>
  );
}
